import {REACT_APP_CALCOM_ORIGIN} from '@progyny/utils/env'

export function getCancellationUrl(bookingUid: string): string {
  return `${REACT_APP_CALCOM_ORIGIN}/booking/${bookingUid}?cancel=true`
}
